import React, { Component } from "react";
import { RESTExecutor, withDomains } from "../../../lib/domain";
import { BasicHeader } from "../../../components/basic_header";
import Form from "../../../lib/ui/form";
import { Button, message, Row, Select } from "antd";
import { copyStringToClipboard, schema_to_field, showErrorInNotification } from "../../../lib/util";
import Title from "antd/lib/typography/Title";

let table_schema = [
  {
    name: "Table Name",
    index: "name",
    type: "text",
  },
  {
    name: "Schema",
    index: "schema",
    type: "complexconfig",
    toggle_ui_json: true,
    multiple: true,
    count: 1,
    isDraggable: true,
  },
  {
    name: "Filter Config",
    index: "filter_config",
    type: "json",
  },
  {
    name: "APIs",
    index: "allowed_methods",
    type: "select",
    mode: "multiple",
    options: [
      {
        value: "LIST",
        text: "LIST",
      },
      {
        value: "DETAIL",
        text: "DETAIL",
      },
      {
        value: "ADD",
        text: "ADD",
      },
      {
        value: "EDIT",
        text: "EDIT",
      },
      {
        value: "DELETE",
        text: "DELETE",
      },
    ],
  },
];
class TableAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form_data: this.props.edit_data || {},
      edit_id: this.props.edit_id,
      parsers: {},
      parserSchema: [],
    };

    this.list_parsers = RESTExecutor.list().config({
      label: 'parsers'
    }).callbacks((success) => {
      let parsers = {};
      success.result.rows.map((item) => {
        parsers[item.id] = item
      });
      this.setState({
        parsers: parsers
      });
      if (this.props.edit_id) {

        this.setState({
          parserSchema: schema_to_field(parsers[this.props.edit_data.parser_id]?.validation_config || {}),
        })
      }
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.plugins)

    this.post_tables = RESTExecutor.post()
      .config({
        label: "tables",
      })
      .callbacks(
        () => {
          message.success("Table Added", 3);
          this.props.history.goBack();
        },
        (error) => {
          console.log("ERROR", error);
        }
      )
      .connect(props.domains.settings);

    this.patch_tables = RESTExecutor.patch()
      .config({
        label: "tables_detail",
      })
      .callbacks(
        () => {
          message.success("Table Updated", 3);
          this.props.history.goBack();
        },
        (error) => {
          console.log("ERROR", error);
        }
      )
      .connect(props.domains.settings);
  }

  handlePostPatch = (data) => {
    if (this.state.edit_id) {
      //  handle patch
      this.patch_tables.forId(this.state.edit_id).execute(data);
    } else {
      this.post_tables.execute(data);
    }
  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    if (valueKey) {
        newData[valueKey] = value;
    }
    if (appendObj) {
        Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
        [stateKey]: newData
    }, () => {
        typeof callback === 'function' && callback()
    })
}

  render() {
    let post_tables_res = this.post_tables.response();
    let patch_tables_res = this.patch_tables.response();
    const { form_data, edit_id } = this.state;
    let networkState = edit_id ? patch_tables_res : post_tables_res;
    let parser_resp = this.list_parsers.response();
    return (
      <div>
        <BasicHeader title={`Table ${this.props.edit_id ? "Edit" : "Add"}`} />

        <div className="filter-card">
          <Form
            forCreate={edit_id ? true : false}
            initialData={form_data}
            parentData={form_data}
            submitted={this.state.submitted}
            onChange={(data) => {
              this.setState({ form_data: data });
            }}
            fields={table_schema}
            errorMessage={networkState.error_message}
            validationErrors={networkState.validation_errors}
          />
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }}>
              <div></div>
              <span>Parser:</span>
              <Select
                placeholder={"Parser"}
                value={form_data.parser_id}
                showSearch
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                loading={parser_resp.fetching}
                onChange={(value) => {
                  console.log("parser id", value, this.state.parsers[value]);
                  this.stateUpdater({ stateKey: 'form_data', valueKey: 'parser_id', value: value })
                  this.setState({
                    parserSchema: schema_to_field(this.state.parsers[value].validation_config),
                    blocks_schema: schema_to_field(this.state.parsers[value].blocks_config),
                  })
                }}
              >
                {Object.keys(this.state.parsers).map((key) => {

                  let dataItem = this.state.parsers[key] || {}
                  return <Select.Option value={dataItem.id} key={dataItem.id}>
                    {dataItem.name}
                  </Select.Option>
                })}
              </Select>

            </div>

          {form_data.parser_id ?
            <div style={{
              marginTop:10
            }}>
              <div>
                <Row style={{
                  padding: 4
                }} type='flex'
                  justify='space-between'>
                  <Title style={{ margin: 0 }} level={4} type='secondary'>Parser Configs</Title>

                  <Button size='small' type='primary' className='export-btn' onClick={() => {
                    copyStringToClipboard(JSON.stringify(form_data.parse_config || {}));
                    message.success("Copied")
                  }}>Copy To Clipboard</Button>
                </Row>
                <Form
                  hideTitle
                  forCreate={true}
                  initialData={form_data.parse_config || {}}
                  submitted={this.state.submitted}
                  onChange={(data) => {
                    console.log("Changes", data);
                    this.setState({
                      form_data: {
                        ...form_data,
                        'parse_config': data
                      }
                    })
                  }}
                  fields={this.state.parserSchema}
                  submitting={{}}
                  errorMessage={{}}
                  validationErrors={{}}
                />
              </div>
            </div>
            : null}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingTop: 20,
            }}
          >
            <Button
              key="cancel"
              type="danger"
              disabled={networkState.fetching}
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              {/* <CloseOutlined type='close'/> */}
              Cancel
            </Button>
            <Button
              key="submit"
              type="primary"
              disabled={networkState.fetching}
              loading={networkState.fetching}
              onClick={() => {
                this.setState({ submitted: true });
                this.handlePostPatch(form_data);
              }}
            >
              {/* <CheckOutlined type='check' /> */}
              {this.props.okText || "Submit"}
              {/* Submit */}
            </Button>
          </div>
        </div>
      </div>
    );
  }
  componentDidMount() {
    this.list_parsers.execute();
  }
}

export default withDomains(TableAdd, "settings", "plugins");
